import Account from '../../../scenes/player/Register/Account';
import GolfInfo from '../../../scenes/player/Register/GolfInfo';
import NewClubPay from '../../../scenes/player/Register/NewClubPay';
import SetCode from '../../../scenes/player/Register/SetCode/SetCode';

import { IRoute } from '../IRoute';

const RegisterRoutes: IRoute[] = [
  {
    actions: ['invitation', 'notifications'],
    component: SetCode,
    default: true,
    key: 'set-code',
    path: 'set-code'
  },
  {
    actions: ['invitation'],
    component: Account,
    key: 'account/:invitationId',
    path: 'account/:invitationId',
    scope: 'guest'
  },
  {
    actions: [],
    component: Account,
    key: 'account',
    path: 'account',
    scope: 'guest'
  },
  {
    actions: ['user'],
    component: GolfInfo,
    key: 'golf-info',
    path: 'golf-info',
    scope: 'user'
  },
  {
    actions: ['user'],
    component: GolfInfo,
    key: 'golf-info/:clubId',
    path: 'golf-info/:clubId',
    scope: 'user'
  },
  {
    actions: ['clubs', 'errors', 'memberships', 'user'],
    component: NewClubPay,
    key: 'complete/:clubId',
    path: 'complete/:clubId',
    scope: 'user'
  }
];

export default RegisterRoutes;
